import { Component } from 'react';
import PropTypes from 'prop-types';
import { ifElse, prop } from 'ramda';
import classNames from 'classnames';
import Seat from './Seat';
import * as Styled from './Style';
export default class Floor extends Component {
  static propTypes = {
    seats: PropTypes.array.isRequired,
    badgeText: PropTypes.string,
    selectedSeats: PropTypes.array.isRequired,
    onSelectSeat: PropTypes.func.isRequired,
    onDeselectSeat: PropTypes.func.isRequired,
    isTooLargeSeatMap: PropTypes.bool,
    isTooHugeSeatMap: PropTypes.bool,
    disabledSeats: PropTypes.array,
    selectedBusySeats: PropTypes.array,
    isWheelHidden: PropTypes.bool
  };
  static defaultProps = {
    disabledSeats: [],
    selectedBusySeats: [],
    isWheelHidden: true
  };
  UNSAFE_componentWillMount() {
    const {
      seats
    } = this.props;
    if (!seats) throw new Error('Received no seats in SeatsSelect component.');
  }
  onSelectedSeatChange = ifElse(prop('isSelected'), this.props.onSelectSeat, this.props.onDeselectSeat);
  renderSeat = (seat, index) => {
    const {
      selectedSeats,
      disabledSeats,
      selectedBusySeats
    } = this.props;
    const {
      id,
      number,
      type
    } = seat;
    const isDisabled = disabledSeats.includes(number);
    const isSelectedBusySeats = selectedBusySeats.includes(number);
    let newType = type;
    if (isSelectedBusySeats) {
      newType = 'recently-selected';
    } else if (isDisabled) {
      newType = 'busy';
    }
    return /*#__PURE__*/React.createElement(Seat, {
      id: id,
      // на id подвешиваться небезопасно, они могут быть неуникальными
      key: index,
      number: number,
      type: newType,
      isSelected: selectedSeats.includes(number),
      onSelectedChange: this.onSelectedSeatChange
    });
  };
  renderSeats = () => {
    const {
      seats,
      isTooLargeSeatMap,
      isTooHugeSeatMap
    } = this.props;
    return seats.map((row, index) => /*#__PURE__*/React.createElement("div", {
      // eslint-disable-next-line react/no-array-index-key
      key: index,
      className: classNames('ticket__place-row', {
        'many-seats': isTooLargeSeatMap,
        'huge-seats': isTooHugeSeatMap
      })
    }, row.map(this.renderSeat)));
  };
  renderBadge = badgeText => /*#__PURE__*/React.createElement(Styled.Badge, null, /*#__PURE__*/React.createElement(Styled.BadgeText, null, badgeText));
  render() {
    const {
      badgeText,
      isTooHugeSeatMap,
      isWheelHidden
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('ticket__place-picker', {
        'huge-seats': isTooHugeSeatMap,
        'with-badge': !!badgeText
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames('ticket__place-picker--wrap', {
        'huge-seats': isTooHugeSeatMap
      })
    }, badgeText && this.renderBadge(badgeText), isWheelHidden && /*#__PURE__*/React.createElement("div", {
      className: "ticket__place-wheel"
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon icon-wheel"
    })), this.renderSeats())));
  }
}